import styled, { css } from 'styled-components'
import { themeColor, BaseColor, Color, ColorShade, spacing, rem } from '~theme'

type Size = 'small' | 'medium' | 'large'

const getThumbSize = (size: Size) => {
  switch (size) {
    case 'small':
      return spacing(0.75)
    case 'large':
      return spacing(1.25)
    case 'medium':
    default:
      return spacing(1)
  }
}

export const Thumb = styled.div<{ isDisabled?: boolean; isError?: boolean; size: Size }>`
  outline: none;
  width: ${props => getThumbSize(props.size)};
  height: ${props => getThumbSize(props.size)};
  border-radius: ${rem(2)};
  background: ${props => {
    if (props.isDisabled) {
      return themeColor(BaseColor.shade_40)
    }

    if (props.isError) {
      return themeColor(Color.danger)
    }

    return themeColor(Color.primary)
  }};

  display: flex;
  justify-content: center;

  font-size: ${props => {
    switch (props.size) {
      case 'small':
        return rem(14)
      case 'large':
        return rem(18)
      case 'medium':
      default:
        return rem(16)
    }
  }};
`

export const ThumbValue = styled.div<{ isError?: boolean }>`
  transform: translateY(100%);
  color: ${props => (props.isError ? themeColor(Color.danger) : themeColor(BaseColor.shade_50))};
`

export const Track = styled.div<{ size: Size }>`
  height: ${props => {
    switch (props.size) {
      case 'small':
        return rem(4)
      case 'large':
        return rem(8)
      case 'medium':
      default:
        return rem(6)
    }
  }};
  width: 100%;
  background: ${themeColor(BaseColor.shade_30)};
  border-radius: ${rem(18)};
`

export const Mark = styled.div<{ size: Size }>`
  ${props => {
    switch (props.size) {
      case 'small':
        return css`
          width: ${rem(2)};
          height: ${rem(8)};
        `
      case 'large':
        return css`
          width: ${rem(2)};
          height: ${rem(14)};
        `
      case 'medium':
      default:
        return css`
          width: ${rem(2)};
          height: ${rem(10)};
        `
    }
  }};

  background: ${themeColor(BaseColor.shade_40)};
  border-radius: ${rem(100)};
`
